export const FETCH_APPLICATION_REQUEST = 'APPLICATION/FETCH_APPLICATION_REQUEST';
export const FETCH_APPLICATION_SUCCESS = 'APPLICATION/FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_FAILURE = 'APPLICATION/FETCH_APPLICATION_FAILURE';

export const ADD_APPLICATION_REQUEST = 'APPLICATION/ADD_APPLICATION_REQUEST';
export const ADD_APPLICATION_SUCCESS = 'APPLICATION/ADD_APPLICATION_SUCCESS';
export const ADD_APPLICATION_FAILURE = 'APPLICATION/ADD_APPLICATION_FAILURE';

export const UPDATE_APPLICATION_REQUEST = 'APPLICATION/UPDATE_APPLICATION_REQUEST';
export const UPDATE_APPLICATION_SUCCESS = 'APPLICATION/UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_FAILURE = 'APPLICATION/UPDATE_APPLICATION_FAILURE';

export const REMOVE_APPLICATION_REQUEST = 'APPLICATION/REMOVE_APPLICATION_REQUEST';
export const REMOVE_APPLICATION_SUCCESS = 'APPLICATION/REMOVE_APPLICATION_SUCCESS';
export const REMOVE_APPLICATION_FAILURE = 'APPLICATION/REMOVE_APPLICATION_FAILURE';
